import React, {Component} from 'react';
import PropTypes from 'prop-types';


import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLessRounded from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRounded from '@mui/icons-material/ExpandMoreRounded';
import MenuIcon from '@mui/icons-material/Menu';
import { ListItemButton } from '@mui/material';

const s:any = {
  itemicon: {
    minWidth: 34,
    color: '#5B6160',
  }
};

class DynamicMenuParent extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;

  state = {
    open: this.props.openImmediately,
  };

  componentDidMount() {
    // So we only run this logic once.
    if (!this.props.openImmediately) {
      return;
    }

    // Center the selected item in the list container.
    const activeElement = document.querySelector(`.${this.props.classes.active}`);
    if (activeElement && activeElement.scrollIntoView) {
      activeElement.scrollIntoView({});
    }
  }

  handleClick = () => {
    this.setState((state:any) => ({ open: !state.open }));
  };

  render() {
    const {
      children,
      classes,
      onClick,
      openImmediately,
      title,
      ...other
    } = this.props;

    const {index,activeid} = this.props;
    const active = (index === activeid);

    return (
      <React.Fragment>
      <ListItem onClick={this.handleClick} {...other} disablePadding sx={{ display: 'block' }}>
        <ListItemButton 
          selected={active}
          sx={{
            minHeight: 50,
            mx: 1,
            my: 0.2,
            px: 1.5,
            borderRadius: '9px',
            color: '#454A49',
            '&:hover': {
              bgcolor: '#FFF5EB',
              color: '#923A00',
              '& .MuiListItemIcon-root': { color: '#D65E00' },
            },
            '&.Mui-selected': {
              bgcolor: '#FFE5C7',
              color: '#923A00',
              '& .MuiListItemIcon-root': { color: '#D65E00' },
            },
            '&.Mui-selected:hover': {
              bgcolor: '#FFDBAF',
            },
          }}>
        <ListItemIcon sx={{...s.itemicon}}>
          <MenuIcon sx={{ fontSize: 21 }} />
        </ListItemIcon>
        <ListItemText
          primary={title}
          primaryTypographyProps={{
            fontSize: 14,
            fontWeight: this.state.open ? 750 : 650,
            noWrap: true,
          }}
        />
        {this.state.open
          ? <ExpandLessRounded sx={{ color: '#D65E00', fontSize: 22 }} />
          : <ExpandMoreRounded sx={{ color: '#5B6160', fontSize: 22 }} />}
        </ListItemButton>
      </ListItem>
      <Collapse in={this.state.open} timeout="auto" unmountOnExit>
        <List
          component="div"
          disablePadding
          sx={{
            mx: 1,
            mb: 0.75,
            py: 0.4,
            bgcolor: '#F8F8F7',
            borderRadius: '9px',
            borderLeft: '3px solid #F27400',
          }}
        >
          {children}
        </List>
      </Collapse>
      </React.Fragment>
    );
  }
}

DynamicMenuParent.propTypes = {
  children: PropTypes.node,
  //classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  openImmediately: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

DynamicMenuParent.defaultProps = {
  openImmediately: false,
};

export default DynamicMenuParent;
